/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '@rebass/grid';
import { getConfigValue, THEME_CONFIG } from '@amtrav/theme-system';
import { BrandLogo } from '@amtrav/graphics';

const MainBackground = styled.div`
  width: 100%;
  background-color: white;
`;

const LogoWrapper = styled(Box)`
  width: 50%;
  padding: 0px 14px;
  max-width: 170px;
  margin-left: 10px;
`;

const HeaderMobile = ({ homeUrl }) => {
  return (
    <MainBackground>
      <a href={homeUrl}>
        <LogoWrapper>
          <BrandLogo token={getConfigValue(THEME_CONFIG.navigation.id.logo)} />
        </LogoWrapper>
      </a>
    </MainBackground>
  );
};

HeaderMobile.propTypes = {
  homeUrl: PropTypes.string,
};

export default HeaderMobile;
